import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './Redux/store';
import { trackPageView } from './utils/analytics';
import NearMeBanner from './components/NearMeBanner/NearMeBanner';
import CookieConsent from './components/CookieConsent/CookieConsent';
import Services from './screen/Services/Services';
import Appointment from './screen/Appointment/Appointment';
import AppointmentList from './components/AppointmentList/AppointmentList';
import Upload from './screen/Upload/Upload';
import Gallery from './screen/Gallery/Gallery';
import About from './screen/About/About';
import Contact from './screen/Contact/Contact';
import FAQ from './screen/FAQ/FAQ';
import Location from './screen/Location/Location';
import Lists from './screen/Lists/Lists';
import Admin from './components/dashboardLayout/dashboardLayout';
import AddStylist from './components/AddStylist/AddStylist';
import Login from './components/Login/Login';
import NotFound from './screen/NotFound/NotFound';

function ExternalRedirect() {
  useEffect(() => {
    window.location.href = 'https://beautypalaceandsupplies.com';
  }, []);
  return null;
}

function AppWithTracking() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return (
    <>
      <Header />
      <Routes>

        <Route path="/" element={<App />} />
        <Route path="/services" element={<Services />} />
        <Route path="/appointments" element={<AppointmentList />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/location" element={<Location />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/addstylist" element={<AddStylist />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/example" element={<ExternalRedirect />} />
        <Route path="*" element={<NotFound />} />
</Routes>
      <CookieConsent />
      <NearMeBanner />
      <Footer />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppWithTracking />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
